import React from 'react';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ForumIcon from "@mui/icons-material/Forum";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";
import {Tooltip} from "react-tooltip";
import { toast } from "react-toastify";
import addBasket from "../assets/img/addBasket.svg";
import deleteBasket from "../assets/img/deleteBasket.svg";
function UrsLine({row,handleToCart,isChild=false,isGroup=false,handleBlock,handleId,handleTest,setBilling,setTest,setComment,data,setIsOpen,isOpen }) {
    return (
        <tr className={row?.isactive?"not_finished":""} key={row?.id} style={(isOpen !== row.clgroup) && isChild ? {
            display: 'none',
            cursor: 'pointer'
        } :{cursor: 'pointer',background: isGroup?'#e5e5e5':isChild?'#efefef':"transparent"}}>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{row?.id}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{new Date(row?.registered).toLocaleString()}</td>
            <td onClick={() => handleId(row?.id)}>{row?.name}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.8125rem' }}>
                    {row?.matrixid}
                    <MuiTooltip title="Copy">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                const text = String(row?.matrixid ?? '');
                                if (text) {
                                    navigator.clipboard.writeText(text).then(() => toast.success('Copied'));
                                }
                            }}
                            sx={{ p: 0.25, '&:hover': { backgroundColor: 'action.hover' } }}
                        >
                            <ContentCopyIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                    </MuiTooltip>
                </span>
            </td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{row?.phone}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.8125rem' }}>
                    {row?.fio}
                    <MuiTooltip title="Copy">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                const text = row?.fio ?? '';
                                if (text) {
                                    navigator.clipboard.writeText(text).then(() => toast.success('Copied'));
                                }
                            }}
                            sx={{ p: 0.25, '&:hover': { backgroundColor: 'action.hover' } }}
                        >
                            <ContentCopyIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                    </MuiTooltip>
                </span>
            </td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{row?.isvip}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{row?.balance}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>{row?.sgs} / {row?.sg}</td>
            <td onClick={() => isGroup?setIsOpen(isOpen === row.clgroup ? '' : row.clgroup):null}>
                <span data-tooltip-content={new Date(row?.testDate).toLocaleString()} data-tooltip-id={row?.testDate} className="d-flex align-items-end">
                    <input className="m-0" type="checkbox"
                           checked={row?.testmode}
                           onChange={() => handleTest(row?.id)}/>
                    <span style={{fontSize: 'small'}}><CalendarMonthIcon
                        onClick={() => setTest(row)} style={{fontSize: 16}}/></span></span>
            </td>
            <td onClick={() => {
                setBilling({
                    member: row?.id,
                    name: data?.billings[row?.admgroup]
                })
            }}>
                {data?.billings[row?.admgroup]}
            </td>
            <td><span className="d-flex align-items-end justify-content-center"><input
                className="m-0" type="checkbox"
                checked={row.isblocked}
                onChange={() => handleBlock(row.id)}/></span>
            </td>
            <td>{row.sdate ? new Date(row.sdate).toLocaleString() : ''}</td>
            <td>{row.history}</td>
            <td>{row.lsum}</td>
            <td>{row.dlinesSum}</td>
            <td><span className="position-relative" onClick={() => setComment(row.id)}><ForumIcon
                style={{fontSize: 24}}/>
                {row.comment_count ? <span
                    className="position-absolute comment_count">{row.comment_count}</span> : null}
                                </span>
                <Tooltip className={"tooltip"} id={row?.testDate}/>

            </td>
            <td onClick={() =>handleToCart(row.id)}>
                {!row.inMemBlock?.status ?<img src={addBasket} alt=""/>:<img src={deleteBasket} alt=""/>}

            </td>

        </tr>
    );
}

export default UrsLine;